// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Yenb","productName":"Table_productName__1q0Mg"};